import client from '@libs/HttpClient';
class SettingService {
  static getSettingData() {
    // for common setting like logo, emails
    return client.get('/setting/get');
  }
  static getGeneralSettingData() {
    return client.get('/setting/general');
  }
  static storeGeneralSettingData(request) {
    return client.post('/setting/general-store', request, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  }
  static getBiometricSettingData() {
    return client.get('/setting/biometric');
  }
  static storeBioMetricSettingData(request) {
    return client.post('/setting/biometric-store', request, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
  }

  static getOtherSettingData() {
    return client.get('/setting/other');
  }

  static storeOtherSettingData(request) {
    return client.post('/setting/other-store', request);
  }
}
export { SettingService };
